import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";

import createApiService from "../../../network";

import PhotosView from "./PhotosView";
import { arrayMove } from "@dnd-kit/sortable";
import { normalize, schema } from "normalizr";
import { fetchCeremonyPhotos } from "../../../actions/ceremonies";
const photoSchema = new schema.Entity("photos");

class PhotosContainer extends Component {
    constructor(props) {
        super(props);

        this.api = createApiService(axios);
    }

    handleReorder = async (oldIndex, newIndex) => {
        const { photos, updateStoreEntities } = this.props;

        const reordered = arrayMove(photos, oldIndex, newIndex);
        const updatedPhotos = reordered.map((photo, index) => ({
            ...photo,
            position: index,
        }));

        const movedPhoto = photos[oldIndex];
        const newPosition = newIndex;

        const normalized = normalize(updatedPhotos, [photoSchema]);

        updateStoreEntities(normalized.entities);

        try {
            await this.api.repositionImageAssets(
                this.props.ceremonyId,
                movedPhoto.id,
                newPosition
            );
            this.props.dispatch(fetchCeremonyPhotos(this.props.ceremony));
        } catch (err) {
            console.error(
                `Failed to update photo ${movedPhoto.id} position`,
                err
            );
        }
    };

    render() {
        return (
            <PhotosView
                onHandleReorder={this.handleReorder}
                items={this.props.photos}
                {...this.props}
            />
        );
    }
}

export default withRouter(PhotosContainer);
